import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "React components as jQuery plugins",
  "description": "",
  "published": "2015-08-07T00:00:00.000Z",
  "redirect_from": ["/blog/using-react-in-the-real-world/swizec/6710"],
  "categories": "Front and back ends, Front End, HTML, JavaScript, jQuery, react, react+d3js, Technical",
  "hero": "./img/p5x14.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Did you know, you can use React without rewriting your whole app?`}</p>
    <p>{`A client recently asked me for a shiny graph. They had an `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Application_programming_interface",
        "title": "Application programming interface"
      }}>{`API`}</a>{` that spits out a lot of data, and they wanted an interactive visualization that would help users make decisions. Deadline was tight, technology restrictions were `}<em parentName="p">{`"As long as it works"`}</em>{`, and specs were loose.`}</p>
    <p><em parentName="p">{`"A-ha!"`}</em>{`, I thought, `}<em parentName="p">{`"This is a job for `}<a parentName="em" {...{
          "href": "http://swizec.com/reactd3js"
        }}>{`React+d3.js`}</a>{`!"`}</em>{`. Small, well-contained, perfect. The best kind of project for testing new technologies.`}</p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "500px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/57d28f99a4d08c58c0fdd558030a0153/41099/p5x14.jpg",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "66.81614349775785%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'267\\'%20viewBox=\\'0%200%20400%20267\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%20134v133h401V0H0v134M121%206c-8%202-8%2013-1%2018l4%202h-4c-4%200-4%201-4%205%201%2011%2019%2011%2019-1%200-5-1-7-7-11l-4-5c0-3%202-3%202%200%200%202%201%203%204%203%204%200%204%200%204-4%200-6-5-9-13-7M98%2022v16h9V6h-9v16m39%200v16h9v-7l1-6v13h20v-2l1-3%201%203v2h25l-1-3c0-3-1-4-3-4s-2%200-2-2V6h-9v32l-2-9-2-16-1-7h-13l-1%2011a158%20158%200%2000-3%2018c-1%201-1-4-1-14V7l-4-1h-5v6l-1%207V6h-9v16m58-3v19h14v-3c0-3-1-4-3-4s-2%200-2-13V6h-9v13m21%201c0%2014%201%2014%203%2017%204%203%2011%203%2015%200%202-3%202-3%202-17V6h-9v14c0%2017-1%2017-1-1V6h-10v14m24-12c-3%203-3%2010%201%2014l4%203%201%201h-8v4c0%206%203%209%2010%209%208%200%2011-3%2010-10-1-6-2-7-8-11-2-2-2-2%202-2s5%200%205-2c0-6-2-8-9-8-5%200-6%200-8%202m19%2014v16h15v-3c0-4%200-4-3-4-4%200-4-5%200-6%204%200%204-6%200-7-4%200-4-4%200-5%203%200%203-1%203-4V6h-15v16m23%2013v3h22v-3c0-4%200-4-3-4-4%200-4%200-4%203l-1%204v-7h-14v4m-146%208c-3%201-5%205-4%206l4-2c2-3%203-3%205-3%203%201%2011%208%2011%2010s3%203%203%200c4-8-10-16-19-11m121%2011l-7%205c-5%204%200%204%206%200%209-6%2015-6%2015-1v3l1-3c3-7-5-9-15-4m-43%2012l-1%202-1%202c0%202-1%203-4%203l-4%202-2%203c-2%202-2%203%200%2010%202%205%206%205%209-1%201-2%201-2%202%200%200%201%201%202%206%203%204%200%206%201%208%203l7%204c3%200%206%202%208%205%203%203%204%203%207%203%206-1%208%201%208%2010l-1%208c-2%200-1%202%203%204l4%203%201-2%201-3%202-3v-1l-1-4v-5l-4-8-2-1-3-3-4-5-3-3-2-1c-2%200-3%200-2-2%200-2-3-3-5-2h-2c-1-2%200-3%202-2l1-1h-3c-3%200-3%200-2-1v-2l-2-1-1-2-2%202h-4c0-1-1-2-3-1-3%200-4-2-2-3s1-3-1-3l-2-2-2-2-2-1c0-4-2-5-2-2m-33%201l-3%202h-3c-2%200-2%200-2%202v4c0%202-2%203-2%201l-2-1%201%202v1h-4l-1%202c0%201-2%202-5%202-6%200-8%201-7%203h-3c-3-2-6%201-5%205%200%202%200%202-1%201-2-2-2-2-5-1-2%202-3%202-2%203v1c-2%201-10%2018-8%2018v2c-3%202-2%204%200%205l1%202c-1%202%203%202%205%200l1-2-1-7%201-8%201-1c-1-2%203-1%204%200%203%203%207%201%2012-4l5-4%207-4c5-2%207-3%2011-3s5-1%205-2c0-2%200-2%202-1l1%203%203%202c3%201%203%201%205-1%203-4%200-16-3-16-1%200-2%200-1-1l-3-6-4%201m-5%2040c-3%203-4%204-4%206l-1%204c-3%203-2%207%203%208l5-1%203-1c2%200%202-1%202-4%200-2%201-4%204-7%204-3%204-5-1-6l-4-1c-2-1-4%200-7%202m29%200c-5%201-6%201-2%207%202%202%203%206%203%207%200%202%205%207%207%207%203%200%2010-3%2010-5l-2-3c-1-2-1-2%207-2h8l-8-1c-7-1-8-2-10-5-2-2-4-4-9-6l-4%201m67%2076l-1%202-2%201h-6c-2-1-2-1-2%201%201%202%201%202-2%201-2-2-4-1-2%201s9%205%2010%204c0-1%203%201%203%203l-3%201c-8-2-11-2-11-1l3%201c2%200%205%203%205%204l-3-1h-3l5%203c6%203%207%205%203%204-2%200-2%200%201%201l4%202%201%204%201%204v2l-2-1c0-2-3-4-4-4v2l1%203%202%201%202%202%201%202c2%203%201%204-2%203-2%200-2%200-1%201l1%202v2c2%202%200%207-2%207-5-2-2%201%205%205l9%205h6c4-2%204-2%202-2-5-1-3-4%202-3l2-2c1-3%200-3-2-4-3-1-3-1-1-2%202%200%202%200%200-2l-1-2-2-2-1-2-2-2c-3-3-3-3-2-4l3%201h1c1-1%200-2-2-3-2%200-4-2-5-3l-1-1-2-1v-1l-2-2-2-2a1522%201522%200%20008-2c-3-1-4-3-2-4l1-2h-2l-2-2c-1-2%201-5%203-4l2-1-1-1v-1c1-1%200-2-2-3s-2-4%201-3c2%201%201-3-1-5h-4l-2-2c-1%200-2%201-1%202m-109%205l-11%203-5%202h-2c-2%202-4%201-4%200%201-3%200-2-2%200s-2%203%201%202l1%201-2%201c-3%200-8%203-8%204l-3%203-3%202c0%202%206%200%209-3%202-2%203-2%203-1l-1%202-1%202%203-1c3-2%204-2%202%201v2l2-2c0-2%201-3%205-5%204-1%204-2%202-2-1-1-1-1%201-1%201%201%203%200%205-1l5-2c1%201%201%200%201-1%200-2%200-2%201-1h4l2-1%202-2%202-2h-9m-32%203l-2%201c-2-1-3%200-1%201%201%201%200%201-1%201-2-1-2-1-1%201%200%202%200%202-2%202-2-1-3%200-2%203l-1%201-3%202c-2%201-2%201%201%201%203-1%204%200%201%202l-1%202c1%202%201%202%202%201l1-2c0-1%204-5%205-4l1-1%202-3%202-3v-2l1%201%201%202%202-4c0-2-4-3-5-2m21%2049v17h9v-14l1%207%201%207h8v-7c0-6%200-8-2-9v-2c3-2%202-9%200-12-1-2-3-2-9-3h-8v16m22-15l-1%2016v16h25v-3c0-4%202-4%202%200%200%203%200%203%204%203l5-1-2-15-2-16-13-1a1110%201110%200%2001-3%2025l-3%201c-5-1-6-6-1-6%204-1%204-7%200-7-4-1-4-5%200-5%203%200%203%200%203-4v-4h-7l-7%201m40%200c-3%201-4%204-4%2016%200%2014%201%2016%209%2016s11-3%2011-9v-5h-9v4l-1%204-1-10%201-11%201%205v4h9v-4c0-4%200-4%203-3h3v25h9v-25h3c2%200%202%200%202-4v-4h-10c-9%200-9%201-9%203%200%203%200%203-3%200s-9-4-14-2\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/57d28f99a4d08c58c0fdd558030a0153/ca0a1/p5x14.webp 223w", "/static/57d28f99a4d08c58c0fdd558030a0153/75680/p5x14.webp 445w", "/static/57d28f99a4d08c58c0fdd558030a0153/b0a15/p5x14.webp 500w"],
                "sizes": "(max-width: 500px) 100vw, 500px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/57d28f99a4d08c58c0fdd558030a0153/853b2/p5x14.jpg 223w", "/static/57d28f99a4d08c58c0fdd558030a0153/0a4fe/p5x14.jpg 445w", "/static/57d28f99a4d08c58c0fdd558030a0153/41099/p5x14.jpg 500w"],
                "sizes": "(max-width: 500px) 100vw, 500px",
                "type": "image/jpeg"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/57d28f99a4d08c58c0fdd558030a0153/41099/p5x14.jpg",
                "alt": "React evil plot",
                "title": "React evil plot",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`React evil plot`}</figcaption>{`
  `}</figure></p>
    <p>{`But their web app was built in Joomla or Wordpress or something. And their front-end stack was `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/JQuery",
        "title": "JQuery"
      }}>{`jQuery`}</a>{`. When I asked the engineer about integration, he talked about framework plugins that create views in PHP and load `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/JavaScript",
        "title": "JavaScript"
      }}>{`JavaScript`}</a>{` files and stuff.`}</p>
    <p>{`It sounded a lot like gems for `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Ruby_on_Rails",
        "title": "Ruby on Rails"
      }}>{`Ruby on Rails`}</a>{`. Tiny packages that work as self-contained apps designed to be integrated into larger projects.`}</p>
    <p>{`They'd been at it for over a year already. The whole thing built out of these framework plugin component things that put most of the hard work on the server, and use JavaScript sparingly.`}</p>
    <p>{`A team of engineers isn't going to rewrite their whole project into React, just so you can make a small component. I wasn't going to ask, and they wouldn't have done it.`}</p>
    <p><em parentName="p">{`I`}</em>{` would have to accommodate `}<em parentName="p">{`them`}</em>{`.`}</p>
    <p>{`But how?`}</p>
    <h2 {...{
      "id": "the-solution"
    }}>{`The solution`}</h2>
    <p>{`Well, at the end of the day it's still just a website. There's a modern browser, `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/HTML",
        "title": "HTML"
      }}>{`HTML`}</a>{`, `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Document_Object_Model",
        "title": "Document Object Model"
      }}>{`the DOM`}</a>{` model, CSS, all the basics.`}</p>
    <p>{`But there's no ES6, no fancy build system, no JavaScript module management. None of the fancy pants future stuff.`}</p>
    <p>{`And you don't need any of that stuff anyway. Not on the deploy side. Not on the user side. You only need that stuff when you're developing. Once `}<a parentName="p" {...{
        "href": "http://webpack.github.io/"
      }}>{`Webpack`}</a>{` is done compiling your code, you've got run of the mill present-day ES5 that runs in any mostly modern browser. I'll tell you more about Webpack later, keep reading.`}</p>
    <p>{`I made my client happy by exporting the whole visualization component into a global function that they could call anywhere. It only took a a bit of forethought:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`const React = require('react'),
           Chart = require('./chart');

function RenderChart(options) {
    React.render(
        <counter>,
        document.querySelectorAll(options.selector)[0]
    );
}

window.RenderChart = RenderChart;
</counter>
`}</code></pre>
    <p>{`Now my client could integrate the React component by just:`}</p>
    <ul>
      <li parentName="ul">{`loading React`}</li>
      <li parentName="ul">{`loading the compiled JS file`}</li>
      <li parentName="ul">{`calling a function with some parameters`}</li>
    </ul>
    <p>{`Yes, there's some overhead with loading the whole React library for just one component. But it's only 38KB after minifying and compressing. jQuery is 29KB and nobody bats an eye.`}</p>
    <p>{`Besides, if you're using a public `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Content_delivery_network"
      }}>{`CDN`}</a>{`, many users well have React cached already. That makes it a 400 byte download to confirm you've got a good version. Not bad at all.`}</p>
    <p>{`But I don't think global functions are the best way to go about integrating a React component. They mess with the global namespace, and they can only do one-way one-time communication. Once you invoke a component, it's left to do own thing, and you have no insight.`}</p>
    <p>{`We can do better.`}</p>
    <h2 {...{
      "id": "react-components-as-jquery-plugins-proof-of-concept"
    }}>{`React components as jQuery plugins, proof-of-concept`}</h2>
    <p>{`We can package React components as jQuery plugins. Yes, we could make Backbone views, yes, we could make Angular components, yes this is an affront to sensible architecture.`}</p>
    <p>{`And it's perfect anyway. Name one website or web app built in the last 10 odd years that doesn't have jQuery? Name one web developer who can't help themselves with a jQuery plugin?`}</p>
    <p>{`Exactly.`}</p>
    <p>{`Here's a proof of concept I prepared earlier:`}</p>
    <p>{`You're looking at a component that tells you how many times you've clicked on The Button. That's it. Nothing fancy.`}</p>
    <p>{`The rest is a normal old school web app. There's some jQuery to render the component, and two jQuery buttons to interact with the component once it's rendered.`}</p>
    <p>{`The jQuery-driven white buttons can both read and write the component's internal state. They need no React to do so. To whomever implements them, they just look like jQuery code.`}</p>
    <h3 {...{
      "id": "using-the-componentplugin"
    }}>{`Using the component/plugin`}</h3>
    <p>{`The `}<em parentName="p">{`"render my component here"`}</em>{` code looks like this:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`$(".container .counter").clickCounter();
`}</code></pre>
    <p>{`Nice and easy - select element, call jQuery plugin. Bam.`}</p>
    <p>{`The plugin exposes its internal state via a `}<inlineCode parentName="p">{`val()`}</inlineCode>{` function. I'll show you what the function looks like later. Using it looks like this:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`// src/integrate.js
$(".btn-10x").click(function () {
  var counter = $(".container .counter").clickCounter()[0];

  counter.val(counter.val() + 10);
});

$(".btn-get").click(function () {
  var val = $(".container .counter").clickCounter()[0].val();

  alert("Current counter value is: " + val);
});
`}</code></pre>
    <p>{`We select an element, get its instance of the plugin, and call `}<inlineCode parentName="p">{`val()`}</inlineCode>{` with or without an argument. Depending on what we need.`}</p>
    <p>{`We're doing `}<inlineCode parentName="p">{`.clickCounter()[0]`}</inlineCode>{` because I didn't know how to properly turn the plugin into a per-element singleton. Getting the reference was easy enough, but jQuery selectors can return arrays and that means I have to return an array as well. But then the `}<inlineCode parentName="p">{`.val()`}</inlineCode>{` function gets confused, which is why we have to access a single element of the returned array.`}</p>
    <p>{`Good enough for now. Anyone who knows how to use jQuery can use our React component. And they don't even need React.`}</p>
    <p>{`Winning.`}</p>
    <h3 {...{
      "id": "packing-react-components-into-jquery-plugins"
    }}>{`Packing React components into jQuery plugins`}</h3>
    <p>{`To turn our React component into a jQuery plugin, we'll have to take care of two things: making the plugin, and compiling our code for the real world.`}</p>
    <p>{`We'll take care of the plugin first.`}</p>
    <p>{`I like to put this code in a `}<inlineCode parentName="p">{`src/main.jsx`}</inlineCode>{` file. It serves as an entry point for the component and exports everything the outside world needs. When somebody wants to use my component from React, they can `}<inlineCode parentName="p">{`require`}</inlineCode>{` the component directly.`}</p>
    <p>{`We load React, the component, and make a render function:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`// src/main.jsx
const React = require('react'),
      Counter = require('./Counter');

function RenderCounter(selector) {
    React.render(
        <counter>,
        document.querySelectorAll(selector)[0]
    );
}
</counter>
`}</code></pre>
    <p>{`This will allow us to both export the function, and set it as a global. Like this:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`module.exports = RenderCounter;
window.RenderCounter = RenderCounter;
`}</code></pre>
    <p>{`Anyone who's got a dependency loader, but isn't using React, can `}<inlineCode parentName="p">{`require`}</inlineCode>{` our component, then call a function to render it inside a particular element.`}</p>
    <p>{`Anyone without a dependency loader, can use the global function.`}</p>
    <p>{`The base for our jQuery plugin comes straight off the `}<a parentName="p" {...{
        "href": "http://jqueryboilerplate.com/"
      }}>{`jQuery boilerplate`}</a>{` project.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`// src/main.jsx
if (typeof jQuery !== 'undefined') {
    (function ($) {
        var pluginName = "clickCounter",
            defaults = {
                value: 0
            };

        function Plugin(element, options) {
            this.element = element;
            this.settings = $.extend({}, defaults, options);
            this._defaults = defaults;
            this._name = pluginName;
            this.init();
        }

        $.extend(Plugin.prototype, {
            init: function () {
                this.component = React.render(
                    <counter value={this.settings.value}>,
                    this.element
                );
                return this;
            },

            val: function (val) {
                if (!arguments.length) {
                    return this.component.state.counter;
                }else{
                    this.settings.value = val;
                    this.init();
                }
            }
        });
    })(jQuery);
}
</counter>
`}</code></pre>
    <p>{`Whew, that's a lot of code.`}</p>
    <p>{`We're only making a plugin if jQuery is available, and we're wrapping its definition in a closure so that we can share the `}<inlineCode parentName="p">{`pluginName`}</inlineCode>{` and `}<inlineCode parentName="p">{`defaults`}</inlineCode>{` variables. Then we're defining a constructor function called `}<inlineCode parentName="p">{`Plugin`}</inlineCode>{`, which stores some basic properties in the newly constructed object, and calls `}<inlineCode parentName="p">{`init`}</inlineCode>{`.`}</p>
    <p>{`Inside `}<inlineCode parentName="p">{`init`}</inlineCode>{`, we render our React component. We didn't have to use `}<inlineCode parentName="p">{`document.querySelectorAll`}</inlineCode>{`, because `}<inlineCode parentName="p">{`this.element`}</inlineCode>{` already refers to the target DOM element.`}</p>
    <p>{`And we defined a `}<inlineCode parentName="p">{`val`}</inlineCode>{` function, which we can use to access our component's internal state. If there's an argument, we change the value, and re-render the component. React is smart enough to say `}<em parentName="p">{`"Hold up there, that's the same component, but with different properties! I'll just update it"`}</em></p>
    <p>{`If `}<inlineCode parentName="p">{`val`}</inlineCode>{` doesn't get an argument, it will return the component's current state.`}</p>
    <p>{`Also notice that React was nice enough to let us access our component's internal state with `}<inlineCode parentName="p">{`this.component.state.counter`}</inlineCode>{`. No React incantation required, just some knowledge of where components store state.`}</p>
    <p>{`Okay, we've got the plugin function. We'll need 5 more lines of code to add the plugin to jQuery:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`// src/main.jsx
        $.fn[pluginName] = function (options) {
            return this.map(function () {
                if (!$.data(this, 'plugin_'+pluginName)) {
                    $.data(this, 'plugin_'+pluginName, new Plugin(this, options));
                }
                return $.data(this, 'plugin_'+pluginName);
            });
        };
    })(jQuery);
`}</code></pre>
    <p>{`This will let us call `}<inlineCode parentName="p">{`$(...).clickCounter()`}</inlineCode>{`. And because it saves each instance of the plugin in each element's `}<inlineCode parentName="p">{`$.data`}</inlineCode>{` collection, we can make sure to treat each instance as a per-element singleton. Every time somebody calls `}<inlineCode parentName="p">{`clickCounter`}</inlineCode>{` on an element, they will get the same object.`}</p>
    <p>{`Which is neat when you want to mess around with components' internal values.`}</p>
    <h3 {...{
      "id": "using-webpack-to-compile-react-for-the-real-world"
    }}>{`Using Webpack to compile React for the real world`}</h3>
    <p>{`Great, we've got the plugin. All we need now is to make a JavaScript file that people in the real world can use.`}</p>
    <p>{`We're going to use Webpack because it's really nice to use. It works primarily as a JavaScript dependency manager much like `}<a parentName="p" {...{
        "href": "http://requirejs.org/"
      }}>{`RequireJS`}</a>{` or `}<a parentName="p" {...{
        "href": "http://browserify.org/"
      }}>{`Browserify`}</a>{`.`}</p>
    <p>{`Webpack analyzes your `}<inlineCode parentName="p">{`require()`}</inlineCode>{` statements to build a dependency tree of your code, and outputs a single JavaScript file that includes everything your code needs. It can potentially split your code into multiple modules, load stylesheets, various JavaScript templating files, and even images.`}</p>
    <p>{`We'll stick to the basics - use React to transform ES6/JSX code into normal present-day JavaScript, and compile a single file for the end-user to load.`}</p>
    <p>{`It doesn't take much, just telling Webpack to treat React and jQuery as externals, and to put the compiled code in a `}<inlineCode parentName="p">{`./build/counter.js`}</inlineCode>{` file. The config looks like this:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`// webpack.config.js
module.exports = {
  entry: ["./src/main.jsx"],
  output: {
    filename: "counter.js",
    path: path.join(__dirname, "build"),
    publicPath: "/build/",
  },
  module: {
    loaders: [
      {
        test: /\\.jsx$/,
        loaders: ["babel"],
        include: path.join(__dirname, "src"),
      },
    ],
  },
  resolve: {
    extensions: ["", ".js", ".jsx"],
  },
  externals: {
    react: "React",
    "react/addons": "React",
    jQuery: "jQuery",
  },
};
`}</code></pre>
    <p>{`With this, we tell Webpack that the entry point for our module is `}<inlineCode parentName="p">{`./src/main.jsx`}</inlineCode>{`. That's where we put the plugin code.`}</p>
    <p>{`Then we told it where to put compiled code - `}<inlineCode parentName="p">{`./build/counter.js`}</inlineCode>{`, and that it should use `}<inlineCode parentName="p">{`babel-loader`}</inlineCode>{` for source files. This allows us to use React's JSX syntax for embedding HTML in JavaScript, as well as all the fancy new ES6 features.`}</p>
    <p>{`Using `}<inlineCode parentName="p">{`externals`}</inlineCode>{`, we explained that both React and jQuery are external dependencies. This way Webpack won't try to bundle them into the compiled file.`}</p>
    <p>{`It might make sense in some cases to bundle both of those into the same file, but we lose the benefit of serving from CDNs and the users's browser cache.`}</p>
    <h2 {...{
      "id": "sum-up"
    }}>{`Sum up`}</h2>
    <p>{`There you go, a React component packaged as a jQuery plugin. For when you don't have the time or the budget to commit to a full rewrite.`}</p>
    <p>{`You write the component as you always would, make a thin jQuery wrapper, and make sure people outside the ecosystem can include your file. Bam.`}</p>
    <p>{`You can find the whole example code on Github, `}<a parentName="p" {...{
        "href": "https://github.com/Swizec/react-real-world"
      }}>{`here`}</a>{`.`}</p>
    <p>{`What have I done ...`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      